export const TAB_SLUG = {
  ALL: 'all',
  DRAFTS: 'drafts',
  IN_PROGRESS: 'in-progress',
  RESOLVED: 'resolved',
} as const;

export type TabSlug = (typeof TAB_SLUG)[keyof typeof TAB_SLUG];

// ECoach view state can be a real tab, the filters panel, or the session view (none)
export type ECoachView = TabSlug | 'filters' | 'none';

export const TAB_SLUGS: readonly TabSlug[] = [
  TAB_SLUG.ALL,
  TAB_SLUG.DRAFTS,
  TAB_SLUG.IN_PROGRESS,
  TAB_SLUG.RESOLVED,
] as const;

export const isTabSlug = (value: string): value is TabSlug =>
  (TAB_SLUGS as readonly string[]).includes(value);
